import { addToast } from "@caprikorn/dynamo-ui";
import type { FetchiosError, FetchiosResponse } from "@caprikorn/dynamo-utils";
import { useMutation } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { ExportDataParams } from "./apiEcms.types";

const postExportDataRequest = ({
  fileType,
  type,
  dateRange,
  perimeter,
}: ExportDataParams) =>
  apiEcmsHttp.post("/export-data/request", {
    fileType,
    type,
    dateRange,
    perimeter,
  });

export const usePostExportDataRequest = () => {
  const { currentGroup } = useGroupReferences();
  const { t } = useCustomTranslation("main");

  return useMutation<FetchiosResponse, FetchiosError, ExportDataParams>({
    mutationFn: postExportDataRequest,
    mutationKey: [QUERY_KEYS.EXPORT_DATA_REQUEST, currentGroup],
    onSuccess: () => {
      addToast({
        variant: "success",
        title: t("perimeter.dataExportDrawer.success.title"),
        description: t("perimeter.dataExportDrawer.success.description"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("perimeter.dataExportDrawer.error.title"),
        description: t("perimeter.dataExportDrawer.error.description"),
      });
    },
  });
};
